import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createSlots as _createSlots, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de1f6e08"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("选择")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 合同金额")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "（请在页签“付款信息”中设置）", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("不确定")
const _hoisted_6 = { "element-loading-text": "正在读取数据，请稍后" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 部门批核人 ")
const _hoisted_8 = {
  key: 0,
  class: "vo-ft-dag"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 使用/需求确认 ")
const _hoisted_10 = {
  key: 0,
  class: "vo-ft-dag"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 会签审批 ")
const _hoisted_12 = {
  key: 0,
  class: "vo-ft-dag"
}

import { ref, unref, reactive, watch, onMounted } from 'vue';
import { ElForm, FormRules } from 'element-plus';
import { userFormRule } from '@/store/formrules';
import { propTypes } from '@/utils/propTypes';
import { GetPartType, GetCurrency } from '@/helpers/statusHelpers';
import { ContractDetail } from '@/apis/contract/contract.type';
import { useAppStore } from '../../../store/app';
import { useCtCategory } from '@/store/category.store';
import { GetMainstaySelectApi } from '@/apis/basics/mainstay.api'
import { GetCatValidInfoApi } from '@/apis/ct_categorys/category.api';
import Selecteds from '@/views/consignee/components/Selected.vue';
import UserSelect from '@/components/selected/Users/Index.vue';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  props: {
	isPreview: propTypes.bool.def(false),
	isEditor: propTypes.bool.def(false),
},
  emits: ['onAmountFlagChange', 'categoryChange', 'mainstayChange'],
  setup(__props, { expose, emit: $emit }) {

const props = __props





const { getLoginInfo } = useAppStore();
const formRules = userFormRule().getContractRules;

const rules = reactive<FormRules>(formRules);
const tabProp = reactive({});

const elFormRef = ref<ComponentRef<typeof ElForm>>();
const cpSelectRef = ref<InstanceType<typeof Selecteds>>();

const state = reactive({
	loadUser: false,
	categoryList: [] as any[],
});

/* 合同表单数据 */
const formSchema = ref<any>({
	created_time: '',
	code: '',
	no: '',
	name: '',
	contract_type: '',
	contract_amount: 0,
	currency: 'RMB',
	payment: '',
	contract_source: '',
	contract_limit: '',
	begin_day: '',
	end_day: '',
	mainstay_id: '', // login.company_id,
	plan_a_name: '', // login.company_name,
	counterpart_id: '',
	counterpart_name: '',
	sign_day: moment().format('YYYY-MM-DD'),
	remark: '',
	status: '1',
	tenant_id: '',
	is_approve: '',
	work_id: '',
	created_user_id: '',
	phone: '',
	folder_id: 0,
	counterpartList: [],
	payplanList: [],
	emp_used_list: [],
	emp_sign_list: [],
	emp_audit_list: [],
	amount_flag: 'Y',
	category_id: '',
	funds_flag: 1,
	second_list: [],
	president_list: [],
	chairman_list: [],
	apply_User: getLoginInfo ? `${getLoginInfo.user_name}(${getLoginInfo.user_account})` : '', // 申请人
});

/* 点击选择相对方 */
const onSelectBtnClick = () => {
	unref(cpSelectRef)?.pubMethods.showCpDialog();
};

/* 选择相对方后 */
const onSelectConsignee = (val: any) => {
	unref(formSchema).counterpartList = [
		{
			counterpart_id: val.id,
			counterpart_name: val.name,
			counterpart_address: val.address,
			counterpart_contract: val.contract,
			counterpart_contract_num: val.contract_num,
			category_name: GetPartType(val.part_type_id).text,
			code: val.no,
		},
	];

	unref(formSchema).counterpart_name = val.name;

	/* 关闭对话框 */
	unref(cpSelectRef)?.pubMethods.closeCpDialog();
};

const methods = {
	setFormData: (data: ContractDetail) => {
		formSchema.value = data;
	},

	setContractNum: (ctNum: string) => {
		unref(formSchema).no = ctNum;
		unref(formSchema).code = ctNum;
	},

	setAmounts: (amt: number) => {
		unref(formSchema).contract_amount = amt;
	},

	setCurrency: (cyKey: string) => {
		unref(formSchema).currency = cyKey;
	},

	getFormData: () => {
		return unref(formSchema);
	},

	setUserLoad: (isLoad: boolean) => {
		state.loadUser = isLoad;
	},
};

/* 我方主体 */
const mainstayloading = ref<boolean>(false);
const mainstayList = ref<any[]>([]);

const getMainstayList = (key: string) => {
	mainstayloading.value = true;

	GetMainstaySelectApi(key)
		.then((res) => {
			mainstayList.value = res.data || [];
		})
		.finally(() => {
			mainstayloading.value = false;
		});
};

/* 选择合同分类 */
const onChanges = (data: any, node: any) => {
	const parentNode = node.parent;

	if (parentNode && node.level == 2) {
		unref(formSchema).category = parentNode.data.code || 'Unknow Type';
		unref(formSchema).contract_type = data.code;
		unref(formSchema).category_id = data.id;

		$emit('categoryChange', data.id);
	}
};

const onMainstayChange = (data: any) => {
	$emit('mainstayChange', data);
};

const watchFuncs = {
	options: { immediate: true, deep: true },
	/* 分类 */
	category: async (catId: string) => {
		const schema = unref(formSchema);
		const categoryId = catId;
		const mainstayId = schema.mainstay_id;

		if (categoryId && mainstayId) {
			checkValid(categoryId, catId);
		}
	},

	/* 主体 */
	mainstay: async (mtId: string) => {
		const schema = unref(formSchema);
		const categoryId = schema.category_id;
		const mainstayId = mtId;

		if (categoryId && mainstayId) {
			checkValid(categoryId, mtId);
		}
	},
};

watch(() => unref(formSchema).category_id, watchFuncs.category, watchFuncs.options);
watch(() => unref(formSchema).mainstay_id, watchFuncs.mainstay, watchFuncs.options);

/* 获取验证规则 */
const checkValid = async (categoryId: string, mainstayId: string) => {
	if (categoryId && mainstayId) {
		const validRes = await GetCatValidInfoApi(categoryId, mainstayId);
		if (validRes.succeeded) {
			(validRes.data || []).forEach((item: any) => {
				tabProp[item.node_id] = { tips: item.tips, required: item.is_required };
			});
		}
	}
};

/* Radio组件Change事件 */
const onRadioChange = (val: string) => {
	unref(formSchema).contract_amount = 0;
	$emit('onAmountFlagChange', { amount_flag: val });
};

onMounted(async () => {
	getMainstayList('');
	state.categoryList = useCtCategory().getTreeList();
});

expose({ elFormRef, methods });

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ElForm), {
      size: "small",
      ref_key: "elFormRef",
      ref: elFormRef,
      "label-position": "top",
      model: formSchema.value,
      rules: _unref(rules),
      disabled: props.isPreview,
      style: {"padding":"0px 10px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 18 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { gutter: 10 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "合同名称",
                          prop: "name"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formSchema.value.name,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.name) = $event)),
                              placeholder: "请输入合同名称"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "合同编号",
                          prop: "no"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formSchema.value.no,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.no) = $event)),
                              placeholder: "合同编号"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "合同类型",
                          prop: "category_id"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_tree_select, {
                              style: {"width":"100%"},
                              modelValue: formSchema.value.category_id,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSchema.value.category_id) = $event)),
                              data: _unref(state).categoryList,
                              accordion: "",
                              filterable: "",
                              clearable: "",
                              placeholder: "请选择合同分类",
                              "default-expanded-keys": [formSchema.value.category_id],
                              onCurrentChange: onChanges
                            }, null, 8, ["modelValue", "data", "default-expanded-keys"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "合同期限类型",
                          prop: "contract_limit"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: formSchema.value.contract_limit,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSchema.value.contract_limit) = $event)),
                              style: {"width":"100%"},
                              placeholder: "请选择合同期限类型"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  label: "固定",
                                  value: "1"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "非固定",
                                  value: "2"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_row, { gutter: 8 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "开始日期",
                                  prop: "begin_day"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_date_picker, {
                                      modelValue: formSchema.value.begin_day,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formSchema.value.begin_day) = $event)),
                                      format: "YYYY-MM-DD",
                                      "value-format": "YYYY-MM-DD",
                                      placeholder: "请选择合同开始日期"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "结束日期",
                                  prop: formSchema.value.contract_limit == '1' ? 'end_day' : ''
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_date_picker, {
                                      modelValue: formSchema.value.end_day,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formSchema.value.end_day) = $event)),
                                      format: "YYYY-MM-DD",
                                      "value-format": "YYYY-MM-DD",
                                      placeholder: "请选择合同开始日期"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }, 8, ["prop"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "订立来源",
                          prop: "contract_source"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              style: {"width":"100%"},
                              modelValue: formSchema.value.contract_source,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formSchema.value.contract_source) = $event)),
                              placeholder: "请选择合同订立来源"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  label: "招标",
                                  value: "ZB"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "补充合同",
                                  value: "BCHT"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "续签合同",
                                  value: "LXHT"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "其他",
                                  value: "QT"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "我方主体",
                          prop: "mainstay_id"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              style: {"width":"100%"},
                              modelValue: formSchema.value.mainstay_id,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formSchema.value.mainstay_id) = $event)),
                              filterable: "",
                              remote: "",
                              "reserve-keyword": "",
                              "remote-show-suffix": "",
                              "remote-method": getMainstayList,
                              loading: mainstayloading.value,
                              clearable: "",
                              placeholder: "请选择我方主体",
                              onChange: onMainstayChange
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainstayList.value, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: item.name,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "loading"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "相对方",
                          prop: "counterpart_name"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formSchema.value.counterpart_name,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formSchema.value.counterpart_name) = $event)),
                              readonly: ""
                            }, _createSlots({ _: 2 }, [
                              (!props.isPreview)
                                ? {
                                    name: "append",
                                    fn: _withCtx(() => [
                                      _createVNode(_component_el_button_group, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_button, {
                                            class: "voa-sp-btn",
                                            onClick: onSelectBtnClick
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_1
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  }
                                : undefined
                            ]), 1032, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "发起人电话",
                          prop: "phone"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formSchema.value.phone,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formSchema.value.phone) = $event)),
                              maxlength: "13",
                              placeholder: "请输入发起人电话"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "签订日期",
                          prop: "sign_day"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              style: {"width":"100%"},
                              modelValue: formSchema.value.sign_day,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formSchema.value.sign_day) = $event)),
                              type: "date",
                              format: "YYYY-MM-DD",
                              "value-format": "YYYY-MM-DD",
                              placeholder: "请录入签订日期"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, null, {
                          label: _withCtx(() => [
                            _hoisted_2,
                            _hoisted_3
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formSchema.value.contract_amount,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formSchema.value.contract_amount) = $event)),
                              disabled: true,
                              placeholder: "请在“付款信息”页签中填写合同金额"
                            }, {
                              append: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(GetCurrency)(formSchema.value.currency)), 1)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 8 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "金额类型",
                          prop: "amount_flag"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_group, {
                              modelValue: formSchema.value.amount_flag,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formSchema.value.amount_flag) = $event)),
                              onChange: onRadioChange
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_radio_button, { label: "Y" }, {
                                  default: _withCtx(() => [
                                    _hoisted_4
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_radio_button, { label: "N" }, {
                                  default: _withCtx(() => [
                                    _hoisted_5
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "摘要",
                          prop: "remark"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formSchema.value.remark,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formSchema.value.remark) = $event)),
                              rows: "6",
                              "show-word-limit": "",
                              maxlength: "300",
                              type: "textarea"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_el_form_item, { label: "申请人" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formSchema.value.apply_User,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formSchema.value.apply_User) = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: `部门批核人`,
                    prop: `${_unref(tabProp)['19902'] && _unref(tabProp)['19902'].required == 'Y' ? 'emp_audit_list' : ''}`
                  }, {
                    label: _withCtx(() => [
                      _hoisted_7,
                      (_unref(tabProp)['19902'] && _unref(tabProp)['19902'].tips && _unref(tabProp)['19902'].required == 'Y' && formSchema.value.status == '1')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, " (" + _toDisplayString(_unref(tabProp)['19902'].tips) + ") ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(UserSelect, {
                        modelValue: formSchema.value.emp_audit_list,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formSchema.value.emp_audit_list) = $event)),
                        priview: props.isPreview
                      }, null, 8, ["modelValue", "priview"])
                    ]),
                    _: 1
                  }, 8, ["prop"]),
                  _createVNode(_component_el_form_item, {
                    label: "使用/需求确认",
                    prop: `${_unref(tabProp)['19903'] && _unref(tabProp)['19903'].required == 'Y' ? 'emp_used_list' : ''}`
                  }, {
                    label: _withCtx(() => [
                      _hoisted_9,
                      (_unref(tabProp)['19903'] && _unref(tabProp)['19903'].tips && _unref(tabProp)['19903'].required == 'Y' && formSchema.value.status == '1')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, " (" + _toDisplayString(_unref(tabProp)['19903'].tips) + ") ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(UserSelect, {
                        modelValue: formSchema.value.emp_used_list,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formSchema.value.emp_used_list) = $event)),
                        priview: props.isPreview
                      }, null, 8, ["modelValue", "priview"])
                    ]),
                    _: 1
                  }, 8, ["prop"]),
                  _createVNode(_component_el_form_item, {
                    label: "会签人",
                    prop: `${_unref(tabProp)['19904'] && _unref(tabProp)['19904'].required == 'Y' ? 'emp_sign_list' : ''}`
                  }, {
                    label: _withCtx(() => [
                      _hoisted_11,
                      (_unref(tabProp)['19904'] && _unref(tabProp)['19904'].tips && _unref(tabProp)['19904'].required == 'Y' && formSchema.value.status == '1')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, " (" + _toDisplayString(_unref(tabProp)['19904'].tips) + ") ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(UserSelect, {
                        modelValue: formSchema.value.emp_sign_list,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formSchema.value.emp_sign_list) = $event)),
                        priview: props.isPreview
                      }, null, 8, ["modelValue", "priview"])
                    ]),
                    _: 1
                  }, 8, ["prop"]),
                  _createVNode(_component_el_form_item, { label: "分管高级总监/副总裁审批" }, {
                    default: _withCtx(() => [
                      _createVNode(UserSelect, {
                        modelValue: formSchema.value.second_list,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formSchema.value.second_list) = $event)),
                        priview: props.isPreview
                      }, null, 8, ["modelValue", "priview"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "执行副总裁审批" }, {
                    default: _withCtx(() => [
                      _createVNode(UserSelect, {
                        modelValue: formSchema.value.president_list,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formSchema.value.president_list) = $event)),
                        priview: props.isPreview
                      }, null, 8, ["modelValue", "priview"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "董事长审批" }, {
                    default: _withCtx(() => [
                      _createVNode(UserSelect, {
                        modelValue: formSchema.value.chairman_list,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formSchema.value.chairman_list) = $event)),
                        priview: props.isPreview
                      }, null, 8, ["modelValue", "priview"])
                    ]),
                    _: 1
                  })
                ])), [
                  [_directive_loading, _unref(state).loadUser]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules", "disabled"]),
    _createVNode(Selecteds, {
      ref_key: "cpSelectRef",
      ref: cpSelectRef,
      onOnSelect: onSelectConsignee
    }, null, 512)
  ], 64))
}
}

})